import { Injectable } from '@angular/core';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UserRelationshipGroup, RelationshipDataGroup, Privilege, PrivilegeGroup } from './models/UserRelationship';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserRelationshipService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  find(): Observable<UserRelationshipGroup[]> {
    const api = (<any>_GlobalNS).api.user.userRelationshipGroup;
    return this._http.get<any>(`${api}`, {});
  }

  update(userRelationshipGroup: UserRelationshipGroup[]): Observable<UserRelationshipGroup[]> {
    const api = (<any>_GlobalNS).api.user.update;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, userRelationshipGroup , this.httpOptions);
  }

/*
get current person(logged in) details
*/
  findByPerson(operatorOnly: boolean = true): Observable<UserRelationshipGroup[]> {
    const api = (<any>_GlobalNS).api.user.userRelationshipGroup;
    const params = new HttpParams().set('OperatorOnly', operatorOnly.toString());
    return this._http.get<any>(`${api}`, { params }).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  displayMoreDialog(moreDialog, event, moreDialogDataObj, moreType): string {
    let moreData: string;
    if (moreType === 'ASSETGROUP') {
      moreData = this.assetGroupList(moreDialogDataObj);
    } else if (moreType === 'PRIVILEGES') {
      moreData = this.privilegeList(moreDialogDataObj);
    }
    return moreData;
  }

  assetGroupList(relationshipDataGroup: RelationshipDataGroup[]): string {
    const aData: any = [];
    if (relationshipDataGroup !== null && relationshipDataGroup !== undefined && relationshipDataGroup.length > 0) {
      for (let i = 0, group = relationshipDataGroup; i < group.length; i++) {
        aData.push(group[i].RelationshipGroupName);
      }
    }
    return aData.join(', ');
  }

  privilegeList(privileges: Privilege[], privilegeGroups?: PrivilegeGroup[], asString: boolean =  true): any {
    const aData: any = [];
    let aGroup: any = [];
    let aGroupPrivilege: any = [];
    if (privilegeGroups !== null && privilegeGroups !== undefined && privilegeGroups.length > 0) {
      privilegeGroups.filter((privileGroupFilter: PrivilegeGroup) =>
        (privileGroupFilter.Enabled === undefined || privileGroupFilter.Enabled))
          .map((privileGroup: PrivilegeGroup) => {
          aGroup = [];
          aGroupPrivilege = [];
          privileGroup.Privileges.filter((privilegeFilter: Privilege) => (privilegeFilter.Enabled === undefined || privilegeFilter.Enabled))
            .map((privilege: Privilege) => {
            aGroupPrivilege.push(privilege.PrivilegeName);
          });
        aGroup.push(`${privileGroup.GroupName} (${aGroupPrivilege.join(', ')})`);
        aData.push(aGroup.join(', '));
      });
    }
    if (privileges !== null && privileges !== undefined && privileges.length > 0) {
      privileges.filter((privilegeFilter: Privilege) => (privilegeFilter.Enabled === undefined || privilegeFilter.Enabled))
        .map((privilegeMap: Privilege) => aData.push(privilegeMap.PrivilegeName));
    }
    return asString ? aData.join(', ') : aData;
  }

}
